import React, { createContext, useContext } from 'react';
import { Labels, useLabels } from '../hooks/useLabels';
import { useConfigContext } from './ConfigContext';

type LabelsContextValue = {
  labels: Labels | null;
}

const LabelsContext = createContext<LabelsContextValue | null>(null);

export const LabelsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { config } = useConfigContext();
  const { labels, isLoading } = useLabels(config);

  if (isLoading) return null;

  return (
    <LabelsContext.Provider value={{ labels }}>
      {children}
    </LabelsContext.Provider>
  );
};

export function useLabelsContext() {
  const context = useContext(LabelsContext);
  if (!context) {
    throw new Error('useLabelsContext must be used within a LabelsProvider');
  }
  return context;
}
